
import MetisMenu from "metismenujs/dist/metismenujs";
import { generateMagicLinkMenu, generateMenu } from "./../menu";
import moment from "moment";
import {
  layoutComputed,
  chatsActions,
  chatsGetters,
  chatsMutations,
} from "~/store/helpers";
import { mapState } from "vuex";
import debounce from "lodash/debounce";

/**
 * Sidebar component
 */
export default {
  data() {
    return {
      itemId: null,
      loadingNewPatients: false,
      loading: false,
      loadingChats: true,
      perPage: 20,
      currentPage: 1,
      patientListCopy: [],
      text: null,
      flag: null,
      value: null,
      searchPatientInput: null,
      adminMenuStyle: {
        color: "#7B8190",
        margin: "0px 10px",
        "font-weight": "450",
      },
      previousRoute: null,
      chatRoute: null,
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    ...chatsGetters,
    ...mapState("chat", ["unreadCount"]),
    logoRedirect() {
      return `/magic-link`;
    },
    patientsList(state) {
      return this.getChatPatients();
    },
    allPatients(state) {
      return this.getSearchedPatients();
    },
    navItems() {
      return generateMagicLinkMenu(this.$route, this).filter((item) => {
        if (item.roles && item.roles.length > 0) {
          return item.roles.some((e) => this.$auth.user.all_roles.includes(e));
        } else {
          return true;
        }
      });
    },
  },
  mounted() {
    var menuRef = new MetisMenu("#side-menu");
    this._activateMenuDropdown();
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        if (
          els[0].children[0].children[0] &&
          els[0].children[0].children[0].className == "is-online"
        ) {
          els[0].children[0].children[0].style.display = "block";
        }
        els[0].classList.remove(className);
      }
    },
    _activateMenuDropdown() {
      this._removeAllClass("mm-active");
      this._removeAllClass("mm-show");
      this.itemId = this.$route.params.id;
      this.$nextTick(() => {
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        const paths = [];

        for (var i = 0; i < links.length; i++) {
          paths.push(links[i]["pathname"]);
        }
        let pathName =
          this.$route.name === "reports"
            ? "/reports"
            : this.$route.name == "index-name"
            ? "/"
            : window.location.pathname.includes("/chats")
            ? "/chats"
            : window.location.pathname.includes("admin/tracks")
            ? "/admin/tracks"
            : window.location.pathname;

        var itemIndex = paths.indexOf(pathName);

        if (itemIndex === -1) {
          const strIndex = window.location.pathname.lastIndexOf("/");
          const item = window.location.pathname.substr(0, strIndex).toString();
          matchingMenuItem = links[paths.indexOf(item)];
        } else {
          matchingMenuItem = links[itemIndex];
        }

        if (matchingMenuItem) {
          matchingMenuItem.classList.add("active");
          var parent = matchingMenuItem.parentElement;
          /**
           * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
           * We should come up with non hard coded approach
           */
          if (parent) {
            parent.classList.add("mm-active");
            if (
              parent.children[0].children[0] &&
              parent.children[0].children[0].className == "is-online"
            ) {
              parent.children[0].children[0].style.display = "none";
            }
            const parent2 = parent.parentElement.closest("ul");
            if (parent2 && parent2.id !== "side-menu") {
              parent2.classList.add("mm-show");
              const parent3 = parent2.parentElement;

              if (parent3) {
                parent3.classList.add("mm-active");
                var childAnchor = parent3.querySelector(".has-arrow");
                var childDropdown = parent3.querySelector(".has-dropdown");
                if (childAnchor) childAnchor.classList.add("mm-active");
                if (childDropdown) childDropdown.classList.add("mm-active");

                const parent4 = parent3.parentElement;
                if (parent4 && parent4.id !== "side-menu") {
                  parent4.classList.add("mm-show");
                  const parent5 = parent4.parentElement;
                  if (parent5 && parent5.id !== "side-menu") {
                    parent5.classList.add("mm-active");
                    const childanchor = parent5.querySelector(".is-parent");
                    if (childanchor && parent5.id !== "side-menu") {
                      childanchor.classList.add("mm-active");
                    }
                  }
                }
              }
            }
          }
        }
      });
    },
  },
};
